import type React from 'react'

// Mở file/URL bằng trình duyệt ngoài App. Với Android native, dùng Chrome intent để tránh
// app-link/deep-link kéo URL cùng domain quay ngược vào App.
export const normalizeUploadUrl = (url?: string) => {
  if (!url) return ''
  const s = String(url).replace('/api/lesson-builder/uploads/', '/api/lesson-builder/upload/')
  // MỌI biến thể URL đã lưu trong DB (/upload/x · /api/upload/x · http(s)://host/upload/x ·
  // /api/lesson-builder/upload/x) → route phục vụ file ỔN ĐỊNH: nó unquote đúng path Unicode
  // (tên bài có dấu/khoảng trắng) và KHÔNG lệ thuộc static mount /api/upload (hay bị proxy 404).
  const m = s.match(/\/api\/lesson-builder\/upload\/(.+)$/) || s.match(/\/(?:api\/)?upload\/(.+)$/)
  if (!m) return s
  // Path tương đối → resolve theo domain đang chạy (prod: /api proxy về backend; dev: vite proxy /api).
  return '/api/lesson-builder/upload/' + m[1].replace(/^\/+/, '')
}

export const absoluteUploadUrl = (url?: string) => {
  const safeUrl = normalizeUploadUrl(url)
  if (!safeUrl) return ''
  try {
    return new URL(safeUrl, window.location.origin).href
  } catch {
    return safeUrl
  }
}

const isAndroidNativeApp = () => {
  const cap = (window as any).Capacitor
  const native = !!cap && (cap.isNativePlatform?.() || cap.getPlatform?.() === 'android')
  return native && /Android/i.test(navigator.userAgent)
}

const chromeIntentUrl = (url: string) => {
  try {
    const u = new URL(url)
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return url
    return `intent://${u.host}${u.pathname}${u.search}${u.hash}#Intent;scheme=${u.protocol.replace(':', '')};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`
  } catch {
    return url
  }
}

export const openExternal = (url?: string) => {
  const safeUrl = absoluteUploadUrl(url)
  if (!safeUrl) return
  if (isAndroidNativeApp()) {
    window.location.href = chromeIntentUrl(safeUrl)
    return
  }
  const opened = window.open(safeUrl, '_blank', 'noopener,noreferrer')
  if (!opened) window.location.assign(safeUrl)
}

// onClick cho thẻ <a>: chặn điều hướng WebView, mở hệ thống.
export const openExternalClick = (url?: string) => (e: React.MouseEvent) => {
  e.preventDefault()
  openExternal(url)
}

// TẢI file về máy từ giao diện WEB: fetch -> blob -> lưu. Nếu file cũ không còn tồn tại,
// fallback sẽ mở bằng trình duyệt ngoài App thay vì điều hướng nội bộ trong App.
export const downloadFile = async (url?: string, filename?: string) => {
  if (!url) return
  try {
    const safeUrl = absoluteUploadUrl(url)
    const resp = await fetch(safeUrl)
    if (!resp.ok) throw new Error(String(resp.status))
    const blob = await resp.blob()
    const obj = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = obj
    a.download = filename || safeUrl.split('/').pop() || 'tai-ve'
    document.body.appendChild(a); a.click(); a.remove()
    setTimeout(() => URL.revokeObjectURL(obj), 4000)
  } catch {
    openExternal(url)
  }
}